import React from 'react'
import { Link } from 'react-router'
import styles from './Nav.scss'
import { Button } from 'common/Button'
import { FollowButton } from 'common/FollowButton'
import { Navbar, NavbarGroup, NavbarTitle } from 'common/Navbar'
import { Icon } from 'common/LegacyIcon'
import { Msg, featureNames, commonVerbs } from 'lib/localization'
import moment from 'moment'
import { FormattedMessage as T } from 'react-intl'

export const formatDate = (date) => {
  if (!date) {
    // no publication date means this report is not yet published and we're
    // previewing.
    return <T id='ShowPageNav.justNow' defaultMessage='just now' />
  } else {
    return moment(date).fromNow()
  }
}

export const Nav = ({ rides, publishedAt, author, reportSlug, canEdit, currentUser, isFollowing, onIsFollowingChange, contestEntry }) => {
  return <Navbar>
    <NavbarGroup>
      <li><NavbarTitle to='/ride_reports'><Msg m={featureNames.rideReports} /></NavbarTitle></li>
      <li>
        <T
          id='ShowPageNav.reportBy'
          // defaultMessage='report by {link}'
          defaultMessage='report by {name}'
          values={{
            name: <Link to={`/ride_reports/user/${author.id}`} className={styles.authorLink}>{author.name}</Link>
          }} />
      </li>
      {currentUser.id && currentUser.id !== author.id &&
        <li><FollowButton isFollowing={isFollowing} onChange={onIsFollowingChange} /></li>}
      <li className={styles.collapse}>{formatDate(publishedAt)}</li>
      {contestEntry && <li><a href='/ride_reports/rollout' target='_blank'><Icon i='star' size={18} /> <span style={{ lineHeight: '18px', display: 'inline-block', verticalAlign: 'middle' }}>Contest Entry</span></a></li>}
    </NavbarGroup>
    <NavbarGroup>
      {rides.length === 1 &&
        <li><a href={`/trips/${rides[0]}`}><T id='ShowPageNav.goToMapView' defaultMessage='Go to map view' /> &raquo;</a></li>}
      {canEdit &&
        <li className={styles.collapse}><Link to={`/ride_reports/${reportSlug}/edit`}><Button><Msg m={commonVerbs.edit} /></Button></Link></li>}
    </NavbarGroup>
  </Navbar>
}
